export default {
  setList (state, payload) {
    state.list = []
    state.list = payload
  }
}